import "./serivce-worker";

import { RouterService } from "./RouterService";
import { GeolocationService } from "./GeolocationService";
import { PushService } from "./PushService";
import { NetworkService } from "./NetworkService";
import { ChatService } from "./ChatService";
import { UserService } from "./UserService";

export class Kommuter {
  
  
  
  
  
  

  constructor() {
    this.router = new RouterService(this);
    this.geolocation = new GeolocationService(this);
    this.push = new PushService(this);
    this.network = new NetworkService(this);
    this.user = new UserService(this);
    this.chat = new ChatService(this);
  }

   init() {
    this.geolocation.init();
    this.user.init();

    return () => {
      this.geolocation.close();
    };
  }
}
